export default {
  buttons: {
    cancel: "Annuler",
    dismiss: "Fermer",
    add_waypoint: "Ajouter une destination"
  },
  distance: {
    value: "{distance, number, distance} {unit}"
  },
  send_to_phone: {
    mail: {
      body: "{url}"
    }
  },
  search: {
    title: "Chercher",
    placeholder: "Entrer un lieu",
    enter_location: "Entrer un lieu",
    help: {
      inactive: "Chercher"
    }
  },
  filters: {
    title: "Filtres",
    amenities: {
      title: "Services"
    },
    fuels: {
      title: "Carburants disponibles"
    }
  },
  directions: {
    title: "Planificateur d'itinéraire",
    placeholder: {
      destination: "Entrer un lieu",
      waypoint: "Entrer un lieu"
    },
    route: {
      title: "Options d'Itinéraire",
      avoid_tolls: "Routes sans péage",
      avoid_highways: "Eviter autoroutes",
      title_corridor: "Distance jusqu'à la station la plus proche"
    },
    travel_time: `\
{weeks, plural, =0 {} =1 {# wk} other {# wks}}
{days, plural, =0 {} =1 {# jour} other {#  journées}}
{hours, plural, =0 {} =1 {# hr} other {# hrs}}
{minutes, plural, =0 {} =1 {# min} other {# min}}\
`,
    button: "Chercher"
  },
  locations: {
    title: "Sites",
    distance: "{distance, number, distance} {unit}",
    distance_from: "{distance, number, distance} {unit} de {place}"
  },
  info_window: {
    title: "Détails station",
    services: "Services",
    nearby: "Proche de ",
    opening_hours: {
      title: "Heures d'ouverture",
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      price: "{price, number, fuelPrice}",
      last_updated_on: "Dernière actualisation",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  itinerary: {
    title: "Planificateur d'itinéraire"
  },
  fuels: {
    autogas_lpg: "Autogas (LPG)",
    midgrade_gasoline: "Shell Unleaded 95 ",
    premium_diesel: "Shell V-Power Diesel",
    premium_gasoline: "Shell V-Power",
    shell_regular_diesel: "Shell Diesel Extra"
  },
  amenities: {
    air_and_water: "Gonflage",
    atm: "Distributeur de billets",
    cafe: "Cafétéria",
    carwash: "Car Wash ",
    credit_card_american_express: "American Express",
    credit_card_diners_club: "Diners International",
    credit_card_mastercard: "Mastercard",
    credit_card_visa: "Visa",
    credit_card: "cartes de crédit",
    deli2go: "Café ",
    euroshell_card: "Carte Euroshell / Shell ",
    fleet_card_dkv: "carte DKV",
    fleet_card_esso: "Carte ESSO",
    fleet_card_general: "carte Fleet",
    fleet_card_uta: "Carte UTA",
    food_offerings: "Offre Alimentaire",
    full_service: "Personnel de piste",
    guarded_car_park: "Parking gardé",
    hgv_lane: "Accessible aux camions ",
    high_speed_diesel_pump: "Pompes haut débit",
    hot_food: "Snack Chaud",
    parking_lanes: "Parking",
    partner_loyalty_accepted: "Carte de fidélité partenaire acceptée",
    pay_at_pump: "Paiement à la pompe",
    self_service: "Self-service",
    service_bay: "Garage",
    shell_card: "Carte Euroshell / Shell ",
    shop: "Boutique",
    shower: "Douches",
    snack_food: "Snack",
    standard_toilet: "Toilettes",
    toilet: "Toilettes",
    truck_parking: "Parking camions",
    truckport: "Camions Seulement",
    twenty_four_hour: "24H",
    twotheloo: "Toilettes",
    vacuum: "Aspirateur",
    adblue_truck: "AdBlue pour camions à la pompe",
    adblue_car: "AdBlue pour voitures à la pompe",
    adblue_pack: "Conteneur AdBlue dans le shop"
  },
  settings: {
    title: "Réglages",
    tooltip: "Réglages",
    distance_units: {
      km: "kilomètres"
    },
    language: {
      title: "Langue"
    }
  }
}
